<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-09-08 17:26:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-11 15:02:14
-->
<template>
  <!-- style="border: 1px solid rgba(0,0,0,0.38);border-radius:8px;" -->
  <v-card outlined
          flat
          rounded="lg">
    <v-card-text>
      <div class="d-flex align-center justify-space-between">
        <!-- <mrc_ess_chip rounded
                small
                :color="list[status]==1?'#18A874':'#ACACAC'">{{list[status]==1?'启用':'禁用'}}
        </mrc_ess_chip> -->
        <span></span>
        <div v-if="!readonly">
          <v-btn icon
                 @click="edit"
                 class="mr-4">
            <v-icon class="material-icons">edit</v-icon>
          </v-btn>
          <v-btn icon
                 @click="deleteItem">
            <v-icon class="material-icons">delete</v-icon>
          </v-btn>
        </div>
        <span v-else></span>
      </div>
      <div>
        <slot :item="list">
          <v-row>
            <v-col cols="12"
                   sm="6">
              <mrc_ess_autoComplete :label="$t('label_Position_Title') + '*'"
                                    :readonly="true"
                                    multiple
                                    positionView
                                    v-model="list.post_uuid"
                                    :prompt_name="company_post">
              </mrc_ess_autoComplete>
            </v-col>
            <v-col cols="12"
                   sm="6">
              <mrc_ess_multiText :label="$t('label_Is_the_level_high_View_the_level_low')"
                                 :readonly="true"
                                 v-model="levle">
              </mrc_ess_multiText>
            </v-col>
            <v-col cols="12">
              <mrc_ess_staffInfo v-model="list.exclude_staff_uuids"
                                 defaultRequest
                                 item-value="staff_id"
                                 :label="$t('label_Exclude_people')"
                                 :readonly="true"
                                 filter="1,2,3,5"
                                 :multiple="true">
              </mrc_ess_staffInfo>
            </v-col>
            <v-col cols="12">
              <tree v-model="list.exclude_function_uuids"
                    :readonly="true"></tree>
            </v-col>
          </v-row>
        </slot>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import tree from './tree'
// 视图显示卡片
export default {
  components: { tree },
  props: {
    readonly: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number,
    },
    status: {
      type: String,
      default: 'status',
    },
    list: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data () {
    return {}
  },
  computed: {
    levle () {
      return this.list.high_grade_switch == 1 ? '是' : '否'
    },
    job_post_uuid () {
      //岗位查询
      return {
        prompt_name: 'job_post',
        org_level_uuid: this.$store.state.currentCompany,
      }
    },
    company_post () {
      return {
        prompt_name: 'company_post',
        org_level_uuid: this.$store.state.currentCompany,
      }
    },
  },
  created () { },
  watch: {},
  mounted () { },
  methods: {
    edit () {
      this.$emit('edit', this.list, this.index)
    },
    deleteItem () {
      this.$emit('deleteItem', this.list, this.index)
    },
  },
}
</script>

<style scoped></style>
